import React from 'react';
import { Container } from 'components/atoms/Page';
import PropTypes from 'prop-types';
import { H2 } from 'components/atoms';

import { FeaturedContentCard } from 'components/molecules';
import './FeaturedContentSection.scss';

export function FeaturedContentSection({ data }) {
	const heading = data?.heading || '';
	const cards = data?.data?.unitCards || [];
	return (
		<section className="featured-card-section">
			<Container>
				<div className="featuredCard-heading">
					<H2 className="card-heading">{heading}</H2>
				</div>
				<div className="featured-unit-cards-arrangement">
					{cards.map((item, index) => (
						<FeaturedContentCard
							item={item}
							index={index}
							key={item.title + index}
						/>
					))}
				</div>
			</Container>
		</section>
	);
}

FeaturedContentSection.propTypes = {
	data: PropTypes.shape({
		heading: PropTypes.string,
		type: PropTypes.string,
		id: PropTypes.string,
		data: PropTypes.shape({
			slug: PropTypes.string,
			unitCards: PropTypes.arrayOf(
				PropTypes.shape({
					title: PropTypes.string.isRequired,
					layout: PropTypes.bool,
					plain: PropTypes.bool,
					date: PropTypes.string,
					image: PropTypes.oneOfType([
						PropTypes.string,
						PropTypes.object,
					]),
					content: PropTypes.string,
				}),
			),
		}),
	}).isRequired,
};

export default FeaturedContentSection;
